import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import styled from '@emotion/styled'
import { Typography } from 'src/components/atoms/Typography'
import { BreakPoint } from 'src/components/shared/CssValues'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import MoreRead from 'src/components/atoms/MoreRead'

const NEWS_LINK_PATH = '/news/'

const CompanyNews = () => {
  const {
    allMarkdownRemark: { edges: newsList }
  } = useStaticQuery(graphql`
    query LatestNewsQuery {
      allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/news/" } }
        sort: { fields: [frontmatter___date], order: DESC }
        limit: 5
      ) {
        edges {
          node {
            frontmatter {
              title
              date(formatString: "YYYY/MM/DD")
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `)
  return (
    <Container>
      <ContentsWrapper>
        <Contents>
          <ContentsLeft>
            <HeadingBorder heading="NEWS" />
            <HeadText as="h2">ニュース</HeadText>
            <PCMoreReadWrapper>
              <MoreRead tag={MoreReadLink} to={NEWS_LINK_PATH} />
            </PCMoreReadWrapper>
          </ContentsLeft>
          <ContentsRight>
            {newsList.map(
              ({
                node: {
                  frontmatter: { date, title },
                  fields: { slug }
                }
              }) => {
                return (
                  <NewsLink to={slug} key={title}>
                    <NewsDate as="p">{date}</NewsDate>
                    <TitleLink as="p">{title}</TitleLink>
                  </NewsLink>
                )
              }
            )}
          </ContentsRight>
        </Contents>

        <SPMoreReadWrapper>
          <MoreRead tag={MoreReadLink} to={NEWS_LINK_PATH} />
        </SPMoreReadWrapper>
      </ContentsWrapper>
    </Container>
  )
}

/**
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
  }
  @media screen and (min-width: ${BreakPoint.TABLET_MIN_WIDTH}) and (max-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
  }
  @media screen and (min-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
  }
*/

const Container = styled.div`
  margin-bottom: 130px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin-bottom: 36px;
  }
`

const NewsLink = styled(Link)`
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-decoration: none;
    width: 100%;
    height: 90px;
    border-bottom: 1px solid #d5d5d5;
    margin: 0 auto;
  }
  @media screen and (min-width: ${BreakPoint.TABLET_MIN_WIDTH}) and (max-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-decoration: none;
    width: 100%;
    height: 70px;
    border-bottom: 1px solid #d5d5d5;
  }
  @media screen and (min-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
    display: flex;
    align-items: center;
    text-decoration: none;
    width: 680px;
    height: 70px;
    border-bottom: 1px solid #d5d5d5;
  }
`

const NewsDate = styled(Typography)`
  font-weight: bold;
  line-height: 21px;
  font-size: 14px;
  color: #254860;
`

const TitleLink = styled(Typography)`
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    color: #000000;
    margin-top: 10px;
    text-decoration: underline;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  @media screen and (min-width: ${BreakPoint.TABLET_MIN_WIDTH}) and (max-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
    color: #000000;
    text-decoration: underline;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    margin-left: 40px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  @media screen and (min-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
    color: #000000;
    text-decoration: underline;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    margin-left: 40px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`

const MoreReadLink = styled(Link)`
  text-decoration: none;
`

const Contents = styled.div`
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    width: 100%;
    margin-top: 120px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  @media screen and (min-width: ${BreakPoint.TABLET_MIN_WIDTH}) and (max-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
    width: 100%;
    margin-top: 120px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  @media screen and (min-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
    width: 100%;
    margin-top: 120px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`

const HeadText = styled(Typography)`
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: 1.92px;
  text-align: left;
  color: #22475d;
  margin-top: 3px;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    font-size: 17.5px;
  }
`

const ContentsLeft = styled.div`
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
  }
`

const ContentsRight = styled.div`
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    width: 100%;
  }
  @media screen and (min-width: ${BreakPoint.TABLET_MIN_WIDTH}) and (max-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
    width: 50%;
    margin-left: 100px;
  }
  @media screen and (min-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
    width: 68.686%;
    display: flex;
    flex-wrap: wrap;
  }
`

// WARN: SP・PCで配置する位置が異なるため、SP・PCでMoreReadWrapperとSPMoreReadWrapperの表示の有無を切り替える必要がある
const PCMoreReadWrapper = styled.div`
  display: block;
  margin-top: 40px;

  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    display: none;
  }
`

const SPMoreReadWrapper = styled.div`
  display: none;

  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    display: flex;
    justify-content: flex-end;
    margin-top: 50px;
  }
`
export default CompanyNews
